const APP_NAME = 'Trauma Scoring'

export {
  APP_NAME
}